import * as React from "react";
import { LineChart } from "@mui/x-charts";
import baseUrl from "../../../../api/baseUrl";

const xLabels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
function getLast7Days() {
  const daysArray = [];
  const today = new Date();

  for (let i = 0; i < 7; i++) {
    const day = new Date(today);
    day.setDate(today.getDate() - i);
    daysArray.push(day.toISOString().split("T")[0]); // Format as 'YYYY-MM-DD'
  }

  return daysArray;
}

const UniquePatientChart = React.memo(() => {
  const [select, setselect] = React.useState("month");
  const [data, setdata] = React.useState<any>({
    series: [],
    xaxis: [],
  });
  const [count, setCount] = React.useState({
    patient: [],
    appointment: [],
    patientWeek: [],
    appointmentWeek: [],
    week: [],
  });

  React.useEffect(() => {
    baseUrl
      .get("client/dashboard/findPatientsChart")
      .then((response) => {
        setCount((prevCount: any) => {
          const newPatientData =
            response.data?.count?.map((item: any) => item.count) || [];
          const newPatientDataWeek =
            response.data?.county?.map((item: any) => item.count) || [];
          const newAppointmentData =
            response.data?.appointment?.map((item: any) => item.count) || [];
          const newAppointmentDataWeek =
            response.data?.appointments?.map((item: any) => item.count) || [];
          const newWeek =
            response.data?.appointments?.map((item: any) => item.date) || [];

          if (
            JSON.stringify(prevCount.patient) !==
              JSON.stringify(newPatientData) ||
            JSON.stringify(prevCount.appointment) !==
              JSON.stringify(newAppointmentData) ||
            JSON.stringify(prevCount.patient) !==
              JSON.stringify(newPatientDataWeek) ||
            JSON.stringify(prevCount.appointment) !==
              JSON.stringify(newAppointmentDataWeek)
          ) {
            return {
              patient: newPatientData,
              appointment: newAppointmentData,
              patientWeek: newPatientDataWeek,
              appointmentWeek: newAppointmentDataWeek,
              week: newWeek,
            };
          }
          return prevCount;
        });
      })
      .catch((error) => {
        console.error(error.response);
      });
  }, []);

  const seriesData = React.useMemo(
    () => [
      {
        data: count.patient,
        label: "Patient",
        area: true,
        stack: "total",
        showMark: false,
        color: "#a8bce2",
      },
      {
        data: count.appointment,
        label: "Appointment",
        area: true,
        stack: "total",
        showMark: false,
        color: "#74a6ea",
      },
    ],
    [count]
  );
  const seriesData1 = React.useMemo(
    () => [
      {
        data: count.patientWeek,
        label: "Patient",
        area: true,
        stack: "total",
        showMark: false,
        color: "#a8bce2",
      },
      {
        data: count.appointmentWeek,
        label: "Appointment",
        area: true,
        stack: "total",
        showMark: false,
        color: "#74a6ea",
      },
    ],
    [count]
  );

  const handleChange = (e: any) => {
    setselect(e.target.value);
    if (e.target.value === "month") {
      setdata({
        series: seriesData,
        xaxis: xLabels,
      });
    } else {
      setdata({
        series: seriesData1,
        xaxis: getLast7Days(),
      });
    }
  };

  return (
    <div className="unique_patient">
      <div className="header">
        <h3>chart</h3>
        <div className="form_buttons">
          <label
            htmlFor="formBtn1"
            className={select === "month" ? "active_btn" : ""}
          >
            Month
            <input
              type="radio"
              name="name1"
              value="month"
              id="formBtn1"
              onChange={(e: any) => handleChange(e)}
            />
          </label>
          <label
            htmlFor="formBtn2"
            className={select === "week" ? "active_btn" : ""}
          >
            Week
            <input
              type="radio"
              name="name1"
              id="formBtn2"
              value="week"
              onChange={(e: any) => handleChange(e)}
            />
          </label>
        </div>
      </div>
      <div className="chart_container">
        <LineChart
          height={600}
          series={data?.series?.length >0 ? data?.series : seriesData}
          xAxis={[
            {
              scaleType: "point",
              data: data?.xaxis?.length >0 ? data?.xaxis : xLabels,
              tickSize: 10,
            },
          ]}
          sx={{
            width: "100%",
            background: "white",
          }}
        />
      </div>
    </div>
  );
});

export default UniquePatientChart;
